// extracted by mini-css-extract-plugin
export default {"new-students":"index_new-students__nONZK","intellect-card-style":"index_intellect-card-style__es8Km"};